var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCentroAyudaQueEs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_57752",
    "data-name": "Grupo 57752",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 81.659,
    height: 70.5,
    viewBox: "0 0 81.659 70.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_25654",
    "data-name": "Rect\\xE1ngulo 25654",
    width: 81.659,
    height: 70.5,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_57751",
    "data-name": "Grupo 57751",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_25653",
    "data-name": "Rect\\xE1ngulo 25653",
    width: 81.659,
    height: 57.712,
    rx: 23.746,
    transform: "translate(0 0)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_11533",
    "data-name": "Trazado 11533",
    d: "M129.107,178.644l-12.786,12.788-12.78-12.788,12.78-12.784Z",
    transform: "translate(-75.494 -120.932)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_11534",
    "data-name": "Trazado 11534",
    d: "M97.113,35.7A19.9,19.9,0,1,0,117.03,55.6,19.938,19.938,0,0,0,97.113,35.7m2.209,30.026a2.2,2.2,0,1,1-4.4,0v-.116a2.2,2.2,0,1,1,4.4,0Zm.072-7.675a.28.28,0,0,0-.072.018v1.207a2.2,2.2,0,1,1-4.4,0v-1.4a4.177,4.177,0,0,1,3.057-4.021l.112-.021A2.99,2.99,0,1,0,94.135,51a2.209,2.209,0,0,1-4.418,0,7.4,7.4,0,1,1,9.677,7.049",
    transform: "translate(-56.28 -26.028)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCentroAyudaQueEs);
export default __webpack_public_path__ + "static/media/Centro_ayuda_que_es.f3023d00cdf4fd304e614197b3653dbf.svg";
export { ForwardRef as ReactComponent };